import React, { PureComponent } from 'react'
import { unreadIndicator } from '../../Email/EmailUtils'
import EmailLink from './StyledEmailLink'
import UnreadIndicator from '../../Email/StyledUnreadIndicator'

class EmailLinkSummary extends PureComponent {
  render () {
    const {
      box,
      widget: {
        meta: {
          link: {
            location
          }
        }
      }
    } = this.props

    return (
      <EmailLink href={location}>
        E-Mail
        {
          box.summary &&
          <UnreadIndicator className={box.summary.unread === 0 ? 'grey' : ''}>
            { unreadIndicator(box.summary.unread) }
          </UnreadIndicator>
        }
      </EmailLink>
    )
  }
}

export default EmailLinkSummary
